import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-project-change-requests',
  templateUrl: './project-change-requests.component.html',
  styleUrls: ['./project-change-requests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectChangeRequestsComponent {}
